import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { CTA_DEVIS } from "@/data/forms";

const navLinks = [
  { to: "/", label: "Accueil" },
  { to: "/a-propos", label: "À propos" },
  { to: "/services", label: "Services" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/notre-processus", label: "Comment ça marche" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <header data-testid="main-header" className="sticky top-0 z-50 bg-white shadow-[0_2px_20px_rgba(0,0,0,0.06)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-4 py-2">
            <Link to="/" data-testid="header-logo" className="flex items-center shrink-0">
              <img src="/logo-228.webp" srcSet="/logo-228.webp 1x, /logo-456.webp 2x" width="114" height="70" alt="VGI Construct" className="h-[70px] w-auto" fetchPriority="high" />
            </Link>
            <nav className="hidden xl:flex items-center gap-6" data-testid="desktop-nav">
              {navLinks.map(link => (
                <Link key={link.to} to={link.to} data-testid={`nav-${link.to.replace("/", "") || "home"}`}
                  className={`text-[13px] xl:text-sm font-bold uppercase tracking-wider whitespace-nowrap transition-colors ${
                    location.pathname === link.to ? "text-[#8B0000]" : "text-[#1a1a1a] hover:text-[#8B0000]"
                  }`}>{link.label}</Link>
              ))}
            </nav>
            <div className="hidden xl:flex items-center gap-4">
              <a href="tel:+32466407988" data-testid="header-phone" className="hidden 2xl:flex items-center gap-2 whitespace-nowrap text-[#1a1a1a] hover:text-[#8B0000] transition-colors text-sm font-bold">
                <Phone size={16} className="text-[#8B0000]" /> +32 466 407 988
              </a>
              <Link to="/demande-devis" data-testid="header-cta" className="btn-primary text-[11px] xl:text-xs px-4 xl:px-5 py-3 whitespace-nowrap">{CTA_DEVIS}</Link>
            </div>
            <button data-testid="mobile-menu-toggle" aria-label="Menu" onClick={() => setMobileOpen(!mobileOpen)} className="xl:hidden text-[#1a1a1a] p-2">
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </header>
      {mobileOpen && (
        <div data-testid="mobile-menu" className="fixed inset-0 z-40 bg-white flex flex-col pt-24 animate-fade-in overflow-y-auto">
          <nav className="flex flex-col items-center gap-6 py-8">
            {navLinks.map(link => (
              <Link key={link.to} to={link.to} data-testid={`mobile-nav-${link.to.replace("/", "") || "home"}`}
                onClick={() => setMobileOpen(false)}
                className={`text-2xl font-black uppercase tracking-wider ${location.pathname === link.to ? "text-[#8B0000]" : "text-[#1a1a1a]"}`}
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{link.label}</Link>
            ))}
          </nav>
          <div className="flex flex-col items-center gap-4 mt-6 px-6 pb-10">
            <a href="tel:+32466407988" className="flex items-center gap-2 text-[#8B0000] text-lg font-bold"><Phone size={20} /> +32 466 407 988</a>
            <Link to="/demande-devis" data-testid="mobile-header-cta" onClick={() => setMobileOpen(false)} className="btn-primary text-sm px-8 py-3 text-center">{CTA_DEVIS}</Link>
          </div>
        </div>
      )}
    </>
  );
}
